<template>
    <div class="h-100">
        <!-- dashboard tab start-->
        <div class="wt-dashborad h-100 mt-3@">
            <div class="container-fluid h-100">                
                <div class=" d-flex justify-content-between">
                    <ul class="nav nav-tabs border-0" id="myTab" role="tablist" v-if="!$route.query.leaderboard">
                        <li class="nav-item" role="presentation">
                            <button class="nav-link " @click="tab = 1" :class="{ 'active': tab == 1 }">{{$t('dashboard')}}</button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link " @click="tab = 2" :class="{ 'active': tab == 2 }">{{$t('leaders')}}</button>
                        </li>
                    </ul>                    
                    <div v-if="tab == 1">
                        <!--  v-if="!$route.query.leaderboard" -->
                        <div class="backBtn"  >
                            <router-link to="/" class="d-inline-flex align-items-center white f-16">
                                <span class="d-flex align-items-center justify-content-center mr-2">
                                    <img src="../../../../static/website/images/arrow-left.svg" >
                                </span>
                                {{$t('back_to_manual_trading')}} 
                            </router-link>
                        </div>
                    </div>
                </div>
                
                <Dashboard
                    @updateTab="ChangeTab"
                    @updateProviderId="updateProviderId"
                    v-if="tab == 1"
                />
                <appOrderHistory v-if="tab == 1 && ProviderId" :providerId="ProviderId" :providerName="providerName"/>
                <app-leaders v-if="tab == 2" @updateTab="ChangeTab"></app-leaders>
            </div>
        </div>
    </div>
</template>
<script>
import AppLeaders from './leaders.vue';
import Dashboard from './dashboard.vue'
import { commonAllmixins } from "@/plugins/commonAll";
import order_history from "../shared/copy-order/order-history";
export default {
    mixins: [commonAllmixins],
    data() {
        return {
            tab: 2,
            ProviderId : 0,
            providerName :''
        }
    },
    components: { AppLeaders,Dashboard,appOrderHistory: order_history },
    methods : {
        ChangeTab(tab) {
            this.tab = tab
        },
        updateProviderId(id,name){
            this.ProviderId = id;
            this.providerName = name;
        }
    },
    mounted(){
        if(this.$route.query.tab == 'dashboard'){
            this.tab = 1
            this.$router.replace({})
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/website/copy-trade/index.vue